export default __webpack_public_path__ + "static/timeline-b314f5c641bfe4091b8f2488e58a4e77.png";